module.exports = __webpack_public_path__ + "assets/img/1213.80dc4a52.png";